import { render } from "./GroupsPage.vue?vue&type=template&id=5f47a6b8&ts=true"
import script from "./GroupsPage.vue?vue&type=script&lang=ts"
export * from "./GroupsPage.vue?vue&type=script&lang=ts"

import "./GroupsPage.vue?vue&type=style&index=0&id=5f47a6b8&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__